import React from 'react';
import { FormattedMessage } from 'react-intl';
import { LinkAsButton, Tooltip } from '@printdeal/ui-library';
import { navigate } from 'gatsby';
import { addDataLayerEntry, addEventEntry } from '@printdeal/data-layer-manager';
import { addYears } from 'date-fns';
import useGetInvoiceChangeAscriptionIsAllowedQuery from '../../../hooks/invoices/useGetInvoiceChangeAscriptionIsAllowedQuery';

interface Props {
  invoiceDate: string;
  invoiceNumber: string;
  changeAscriptionStatus: string | undefined;
}

const InvoiceChangeAscriptionButton = ({ invoiceDate, invoiceNumber, changeAscriptionStatus }: Props) => {
  const withinAYear = (invoiceDateString: string) => (new Date(invoiceDateString)) > addYears(new Date(), -1);

  const getInvoiceChangeAscriptionIsAllowedQuery = useGetInvoiceChangeAscriptionIsAllowedQuery({
    invoiceNumber,
    enabled: ((changeAscriptionStatus === 'declined' || changeAscriptionStatus === 'none') && withinAYear(invoiceDate)),
  });

  const changeAscriptionButton = (
    <LinkAsButton
      variant="secondary"
      iconBefore="edit"
      disabled={!getInvoiceChangeAscriptionIsAllowedQuery.data}
      onClick={() => {
        // GA3
        addEventEntry({
          eventCategory: 'invoice_list',
          eventAction: 'change_ascription_invoice',
        });
        // GA4
        addDataLayerEntry('change_ascription_invoice', {
          action: 'change_ascription_invoice',
        });

        navigate(`../invoices/ascription/${invoiceNumber}`);
      }}
      className="pd-text-sm"
    >
      <FormattedMessage id="account.invoices.list.change.ascription.button" defaultMessage="Change Ascription" />
    </LinkAsButton>
  );

  if (!withinAYear(invoiceDate) && (changeAscriptionStatus === 'declined' || changeAscriptionStatus === 'none')) {
    return (
      <Tooltip
        id="disabled-button"
        trigger={(
          <Tooltip.Trigger>
            {changeAscriptionButton}
          </Tooltip.Trigger>
        )}
      >
        <FormattedMessage id="account.invoices.change.ascription.state.explanation" defaultMessage="Change ascription not possible because the invoice is more than 1 year old." />
      </Tooltip>
    );
  }
  return changeAscriptionButton;
};

export default InvoiceChangeAscriptionButton;
